module.exports = __webpack_public_path__ + "img/videowiki-cast.369a5b7a.svg";